var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Expose } from "class-transformer";
import { IsBoolean, IsDateString, IsInt, IsOptional } from "class-validator";
import { EmploymentType, NominalHoursMode, VacationIncrement } from "../../model";
import { safeAssign } from "./safe-assign";
export class GetContractsParams {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], GetContractsParams.prototype, "employeeId", void 0);
export class GetAllContractsParams {
    constructor(props) {
        this.includeOld = false;
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsOptional(),
    IsBoolean(),
    __metadata("design:type", Boolean)
], GetAllContractsParams.prototype, "includeOld", void 0);
export class CreateNewCurrentContractParams {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    IsInt(),
    __metadata("design:type", Number)
], CreateNewCurrentContractParams.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    IsDateString(),
    __metadata("design:type", String)
], CreateNewCurrentContractParams.prototype, "startDate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], CreateNewCurrentContractParams.prototype, "changes", void 0);
export class ContractDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ContractDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ContractDTO.prototype, "employeeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ContractDTO.prototype, "startDate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ContractDTO.prototype, "endDate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ContractDTO.prototype, "hoursPerWeek", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ContractDTO.prototype, "hoursPerDay", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ContractDTO.prototype, "nominalHoursMode", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ContractDTO.prototype, "nominalWeeklyHours", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ContractDTO.prototype, "employmentType", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ContractDTO.prototype, "maxSalary", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ContractDTO.prototype, "vacationDays", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], ContractDTO.prototype, "vacationIncrement", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], ContractDTO.prototype, "comment", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Boolean)
], ContractDTO.prototype, "blocked", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ContractDTO.prototype, "probationEnd", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], ContractDTO.prototype, "salaries", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], ContractDTO.prototype, "bonuses", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Array)
], ContractDTO.prototype, "benefits", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], ContractDTO.prototype, "hourlyRate", void 0);
export class SalaryDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], SalaryDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], SalaryDTO.prototype, "contractId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], SalaryDTO.prototype, "positionId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], SalaryDTO.prototype, "amount", void 0);
__decorate([
    Expose(),
    __metadata("design:type", String)
], SalaryDTO.prototype, "type", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], SalaryDTO.prototype, "commission", void 0);
export class BonusDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusDTO.prototype, "contractId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Object)
], BonusDTO.prototype, "positionId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusDTO.prototype, "typeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusDTO.prototype, "percent", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusDTO.prototype, "hourlyRate", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BonusDTO.prototype, "fixedAmount", void 0);
export class BenefitDTO {
    constructor(props) {
        safeAssign(this, props);
    }
}
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BenefitDTO.prototype, "id", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BenefitDTO.prototype, "contractId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BenefitDTO.prototype, "typeId", void 0);
__decorate([
    Expose(),
    __metadata("design:type", Number)
], BenefitDTO.prototype, "amount", void 0);
//# sourceMappingURL=contract.dto.js.map